import { z } from "zod";

export const ContractorType = z.enum([
  "GeneralContractor",
  "Subcontractor",
  "Other",
]);

export type ContractorTypeEnum = z.infer<typeof ContractorType>;

export const ContractorTypeDisplayName: Record<ContractorTypeEnum, string> = {
  [ContractorType.enum.GeneralContractor]: "General Contractor",
  [ContractorType.enum.Subcontractor]: "Subcontractor",
  [ContractorType.enum.Other]: "Other",
};

export const ContractorTypeTier: Record<ContractorTypeEnum, string> = {
  [ContractorType.enum.GeneralContractor]: "1",
  [ContractorType.enum.Subcontractor]: "2",
  [ContractorType.enum.Other]: "3",
};

export const ContractorTypeSortOrder: Record<ContractorTypeEnum, number> = {
  [ContractorType.enum.GeneralContractor]: 1,
  [ContractorType.enum.Subcontractor]: 2,
  [ContractorType.enum.Other]: 3,
};
